import debounce from 'lodash.debounce';
import { View } from 'native-base';
import React, {
  useEffect, useMemo, useRef, useState,
} from 'react';
import { Text, TouchableOpacity } from 'react-native';
import AutocompleteInput from 'react-native-autocomplete-input';
import { useApolloClient } from '@apollo/client';
import { SEARCH_LOCATIONS } from '../../gql/geo/query';

const MIN_QUERY_LENGTH = 3;
const DEBOUNCE_MS = 400;

function AutocompleteLocation({
  value,
  handleChangeText,
  handleSubmit,
  disabled,
}) {
  const client = useApolloClient();
  const [locations, setLocations] = useState([]);
  const [error, setError] = useState(false);
  const [hideResults, setHideResults] = useState(false);
  // Only the answer to the latest query may update the list.
  const latestQuery = useRef('');

  // The address search is answered by the API, the app never calls the geocoder itself.
  const search = useMemo(() => debounce(async (query) => {
    try {
      const { data } = await client.query({ query: SEARCH_LOCATIONS, variables: { query } });
      if (latestQuery.current !== query) return;
      setLocations(data.searchLocations);
      setError(false);
    } catch (err) {
      if (latestQuery.current !== query) return;
      setLocations([]);
      setError(true);
    }
  }, DEBOUNCE_MS), [client]);

  useEffect(() => () => search.cancel(), [search]);

  return (
    <AutocompleteInput
      data={error ? ['error'] : locations}
      hideResults={hideResults}
      value={value}
      disabled={disabled}
      onChangeText={(query) => {
        if (!disabled) {
          latestQuery.current = query.trim();
          if (latestQuery.current.length >= MIN_QUERY_LENGTH) {
            search(latestQuery.current);
          } else {
            search.cancel();
            setLocations([]);
            setError(false);
          }
          handleChangeText(query);
          setHideResults(false);
        }
      }}
      renderResultList={({ data, style }) => (
        <View style={{ ...style[0], position: 'relative' }}>
          {error ? (
            <Text>Recherche d&apos;adresse indisponible, saisissez l&apos;adresse complète.</Text>
          ) : data?.map((item) => (
            <TouchableOpacity
              key={item}
              onPress={() => {
                handleSubmit(item);
                setHideResults(true);
              }}
            >
              <Text>{item}</Text>
            </TouchableOpacity>
          ))}
        </View>
      )}
    />
  );
}

export default AutocompleteLocation;
